import React from 'react';
import PropTypes from 'prop-types';
import styles from './Pagination.module.css';

const Pagination = ({ currentPage, totalPages, onPageChange }) => {
    return (
        <div className={styles.paginationContainer}>
            {currentPage > 0 && (
                <a
                    onClick={() => onPageChange(currentPage - 1)}
                    className={styles.paginationLink}
                >
                    Anterior
                </a>
            )}
            <span className={styles.paginationInfo}>
        Página {currentPage + 1} de {totalPages}
      </span>
            {currentPage + 1 < totalPages && (
                <a
                    onClick={() => onPageChange(currentPage + 1)}
                    className={styles.paginationLink}
                >
                    Próxima
                </a>
            )}
        </div>
    );
};

Pagination.propTypes = {
    currentPage: PropTypes.number.isRequired,
    totalPages: PropTypes.number.isRequired,
    onPageChange: PropTypes.func.isRequired,
};

export default Pagination;
